<template>
  <a-form-item
    :label="data.fieldname"
    class="file-box"
  >
    <a-upload
      v-decorator="[
        `${data.fieldkey}`,
        {
          rules: [{
            validator: validateFile,
            message: uploadNeed
          }],
          initialValue: fileList
        },
      ]"
      :action="action"
      :multiple="true"
      :headers="{'X-Requested-With': null}"
      :accept="accept"
      :data="params"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :remove="handleRemove"
      @change="handleChange"
      @preview="onPreview"
    >
      <a-button>
        <a-icon type="upload" />{{ data.labelname || $t('message["986"]') }}
      </a-button>
      <span
        v-if="!data.hideLimitText"
        class="fs-gray"
      >{{ $t('message["1591"]') }}</span>
    </a-upload>
  </a-form-item>
</template>

<script>
import { upyunUpload } from '@/lib/config'
import { uploadSignature } from '@/services/index'

export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    let fileList = this.data.fieldvalue || []
    return {
      action: upyunUpload,
      params: {
        policy: '',
        signature: '',
        file: []
      },
      fileList,
      fileUrls: []
      /* fileList: [{
        uid: '-1',
        name: 'xxx.png',
        status: 'done',
        url: 'http://www.baidu.com/xxx.png'
      }] */
    }
  },
  computed: {
    /* finished () {
      let len = this.fileList.filter(item => item.status !== 'done')
      return len === 0
    } */
    accept () {
      return this.data.accept || '*'
    },
    uploadNeed () {
      return this.$t('message["1610"]')
    }
  },
  watch: {
    data: {
      handler (val) {
        this.fileList = this.data.fieldvalue || []
      },
      deep: true,
      immediate: true
    }
  },
  created () {
    this.setDefault()
  },
  methods: {
    setDefault () {
      if (!this.fileList.length) return
      this.fileList = this.fileList.map(item => {
        item.uid = item.id || 'uid' + Math.random()
        item.name = item.file_name || item.name
        item.url = item.file_url
        item.description = item.name
        item.href = item.file_url
        item.title = this.$t('message["1304"]') // '下载'
        item.status = 'done'
        return item
      })
    },
    handleChange (info) {
      let file = info.file
      let fileList = [...info.fileList]
      /* let fileList = [...this.fileList]
      if (fileList.findIndex(item => file.uid === item.uid) < 0) {
        fileList.push(file)
      } */

      if (file.status === 'error') {
        let index = fileList.find(item => item.name === file.name)
        fileList = fileList.slice(index, 1)
      }
      if (file.status === 'done') {
        console.log(info.file.name)
        this.$message.success(`${info.file.name} ${this.$t('message["1269"]')}`)
      }

      fileList = fileList.map((file, i) => {
        if (file.response) {
          let index = fileList.length - this.fileUrls.length
          if (i >= index) {
            file.file_name = file.name
            file.file_url = this.fileUrls[i - index]
            file.file_size = file.size
            file.file_type = file.type
            file.description = file.name
            file.href = file.file_url
            file.title = this.$t('message["1304"]')
          }
        }
        return file
      })

      this.fileList = fileList
      this.data.fieldvalue = fileList
      // this.fileFinished(this.finished)
      this.$emit('change', fileList)
    },
    async beforeUpload (file) {
      let vm = this
      return new Promise(async (resolve, reject) => {
        if (file.size > 1024 * 1024 * 20) { // 支持20M以内的文件上传
          this.$message.error(this.$t('message["1267"]'))
          return false
        }
        if (this.accept.indexOf('image') !== -1 && file.type && file.type.indexOf('image') === -1) {
          this.$message.error(this.$t('message["1599"]')) // 只能上传图片
          return false
        }
        const chain = await uploadSignature()
        chain.config({
          tip: false
        })
          .params({
            'filename': [file.name] // 文件本地路径
          })
          .onNetSuccess(({ data = {} }) => {
            let { message = '', error } = data
            if (message && error) {
              this.$message.error(message)
            }
          })
          .onSuccess(async ([data = {}]) => {
            const {
              policy,
              signature,
              domain,
              upyunurl,
              _upt
            } = data

            if (policy && signature) {
              vm.file_url = domain + _upt
              vm.params.policy = policy
              vm.params.signature = signature
              vm.action = upyunurl

              vm.fileUrls.push(vm.file_url)
              return resolve(true)
            } else {
              return false
            }
          })
          .fetch()
      })
    },
    handleRemove (file) {
      // this.data.fieldvalue = this.fileList.filter(item => item.file_url !== file.url)
      let index = this.fileList.findIndex(item => item.file_url === file.file_url)
      this.fileList.splice(index, 1)
      this.data.fieldvalue.splice(index, 1)
      // this.fileUrls.splice(index, 1)
      this.$emit('change', this.fileList)
    },
    clearFileList () {
      this.fileList = []
      this.data.fieldvalue = []
    },
    onPreview (file) {
      if (file.file_type.indexOf('image') === -1) {
        this.$confirm({
          title: this.$t('message["1099"]') + '？',
          okText: this.$t('message["915"]'),
          cancelText: this.$t('message["896"]'),
          centered: true,
          // closable: true,
          onOk: () => {
            // window.open(file.url || file.file_url)
            this.$downloadFile(file.url || file.file_url)
          }
        })
      } else {
        let i = this.fileList.findIndex(item => item.file_url === file.file_url)
        if (file.status === 'done') {
          this.$bus.$emit('getFileGallery', this.fileList, i)
        } else {
          this.$message.error(this.$t('message["1225"]'))
        }
      }
    },
    validateFile (rule, value, callback) {
      const { fieldtype, isneeded } = this.data
      if (fieldtype !== 'file' || !isneeded) {
        callback()
        return
      }
      if (this.fileList.length === 0) {
        callback(rule.message)
        return
      }
      callback()
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep .ant-upload-list-item-name {
  color: #5077aa;
  cursor: pointer;
}
</style>
